import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import _get from 'lodash/get';

import { AuthContext } from 'context/AuthContext';

export default function TitleMetaTag({ name }) {
  const { getStoreDetails } = useContext(AuthContext);

  const storeName = _get(getStoreDetails(), 'name', '');

  if (!name || !storeName) {
    return null;
  }

  return (
    <Helmet>
      <title>
        {name} | {storeName} Support
      </title>
    </Helmet>
  );
}
